import { render, staticRenderFns } from "./RiskIdentificationView.vue?vue&type=template&id=8436b676&"
import script from "./RiskIdentificationView.vue?vue&type=script&lang=ts&"
export * from "./RiskIdentificationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports